<div class="resume-dialog">
  <div class="resume-dialog__header">
    <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.TITLE' | i18nextEager }}</h2>
    <span (click)="closeDialog()">
      <img src="/assets/icons/close.svg" alt="" />
    </span>
  </div>
  <div class="resume-dialog__steps">
    <!-- Análisis de riesgo y campaña -->
    <div class="resume-dialog__steps__step" (click)="toggleAnalysis()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.RISK_CAMPAIGN' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: analysisOpen }" />
      </span>
    </div>
    <div *ngIf="analysisOpen">
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.CUPS' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.cups }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.CIF' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.cif }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.CONSUMPTION' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.consumption }} <strong>kWh</strong></span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.CAMPAIGN' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.campaignName }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.LEVEL' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.levelName }}</span>
      </div>
    </div>
    <!-- Razón social -->
    <div *ngIf="tabIndex >= 2" class="resume-dialog__steps__step" (click)="toggleBusiness()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.BUSINESS' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: businessOpen }" />
      </span>
    </div>
    <div *ngIf="businessOpen">
      <div class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.MAIN_DATA' | i18nextEager }}</h3>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.BUSINESS' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.nombre }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.CIF' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.cif }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.CNAE' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.cnae }}</span>
      </div>
      <div class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.RESUME_DIALOG.CONTACT_DATA' | i18nextEager }}</h3>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.nombreContactoComercial }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.apellidosContactoComercial }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.DNI_NIE' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.dniContactoComercial }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.EMAIL' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.mailContactoComercial }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.telefonoContactoComercial }}</span>
      </div>
      <div class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.ADDRESS' | i18nextEager }}</h3>
      </div>
      <div *ngIf="savedDataBusiness?.nombreTipoViaDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.nombreTipoViaDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.nombreDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.nombreDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.numeroDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.numeroDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.portalDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.portalDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.escaleraDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.escaleraDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.pisoDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.pisoDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.puertaDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.puertaDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.codPostalDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.codPostalDireccion }}</span>
      </div>
      <div *ngIf="savedDataBusiness?.nombrePoblacionDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</h3>
        <span>{{ savedDataBusiness?.nombrePoblacionDireccion }}</span>
      </div>
    </div>
    <!-- Datos de instalación -->
    <div *ngIf="tabIndex >= 3" class="resume-dialog__steps__step" (click)="toggleInstallation()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.ISTALLATION_DATA' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: installationOpen }" />
      </span>
    </div>
    <div *ngIf="installationOpen">
      <div class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.MAIN_DATA' | i18nextEager }}</h3>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.INSTALLATION_NAME' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.nombre }}</span>
      </div>
      <div class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.CUPS' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.cups }}</span>
      </div>
      <div *ngIf="isUserSpanish" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.ACCESS_FEE' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.accessFee }}</span>
      </div>
      <div *ngIf="!isUserSpanish" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.TENSION' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.tensionName }}</span>
      </div>
      <div *ngIf="!isUserSpanish" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.CYCLE' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.cycleName }}</span>
      </div>
      <div *ngIf="!isUserSpanish" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.PERIOD' | i18nextEager }}</h3>
        <span>{{ savedDataAnalysis?.periodName }}</span>
      </div>
      <div class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.ADDRESS' | i18nextEager }}</h3>
      </div>
      <div *ngIf="savedDataInstallation?.nombreTipoViaDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.nombreTipoViaDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.nombreDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.nombreDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.numeroDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.numeroDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.portalDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.portalDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.escaleraDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.escaleraDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.pisoDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.pisoDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.puertaDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.puertaDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.codPostalDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.codPostalDireccion }}</span>
      </div>
      <div *ngIf="savedDataInstallation?.nombrePoblacionDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</h3>
        <span>{{ savedDataInstallation?.nombrePoblacionDireccion }}</span>
      </div>
    </div>
    <!-- Datos de pago -->
    <div *ngIf="tabIndex >= 4" class="resume-dialog__steps__step" (click)="togglePayment()">
      <h2>{{ 'NEW_CONTRACTS.RESUME_DIALOG.PAYMENT_DATA' | i18nextEager }}</h2>
      <span>
        <img src="/assets/icons/chevron-enabled.svg" alt="" [ngClass]="{ open: paymentOpen }" />
      </span>
    </div>
    <div *ngIf="paymentOpen">
      <div class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.NOTIFICATION_ADDRESS' | i18nextEager }}</h3>
      </div>
      <div *ngIf="savedDataPayment?.nombreTipoViaDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_TYPE' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.nombreTipoViaDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.nombreDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.nombreDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.numeroDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.numeroDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.portalDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.portalDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.escaleraDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.escaleraDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.pisoDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.pisoDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.puertaDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.puertaDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.codPostalDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.codPostalDireccion }}</span>
      </div>
      <div *ngIf="savedDataPayment?.nombrePoblacionDireccion" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.nombrePoblacionDireccion }}</span>
      </div>
      <div class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.SIGNATURE_DATA' | i18nextEager }}</h3>
      </div>
      <div *ngIf="savedDataPayment?.nombreFirmante" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.NAME' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.nombreFirmante }}</span>
      </div>
      <div *ngIf="savedDataPayment?.apellidosFirmante" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.SURNAME' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.apellidosFirmante }}</span>
      </div>
      <div *ngIf="savedDataPayment?.dniFirmante" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.DNI_NIE' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.dniFirmante }}</span>
      </div>
      <div *ngIf="savedDataPayment?.mailFirmante" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.RESUME_DIALOG.EMAIL' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.mailFirmante }}</span>
      </div>
      <div *ngIf="savedDataPayment?.movilFirmante" class="resume-dialog__steps__step__content">
        <h3>{{ 'NEW_CONTRACTS.MOBILE' | i18nextEager }}</h3>
        <span>{{ savedDataPayment?.movilFirmante }}</span>
      </div>
      <div *ngIf="savedDataPayment?.iban" class="resume-dialog__steps__step__content ">
        <h3 class="black">{{ 'NEW_CONTRACTS.BANK_ACCOUNT' | i18nextEager }}</h3>
      </div>
      <div *ngIf="savedDataPayment?.iban" class="resume-dialog__steps__step__content">
        <h3></h3>
        <span *ngIf="isUserSpanish">
          {{ savedDataPayment?.iban }} {{ savedDataPayment?.entidad }} {{ savedDataPayment?.sucursal }}
          {{ savedDataPayment?.dc }} {{ savedDataPayment?.cuenta }}
        </span>
        <span *ngIf="!isUserSpanish">
          {{ savedDataPayment?.iban }} {{ savedDataPayment?.entidad }} {{ savedDataPayment?.sucursal }}
          {{ savedDataPayment?.cuenta }} {{ savedDataPayment?.dc }}
        </span>
      </div>
    </div>
  </div>
</div>
